
import React, { useState, useEffect } from 'react';
import HomePage from './views/pages/home';
import FretVizPage from './views/pages/fretviz';
import ContactPage from './views/pages/contact';
import PnfHelperPage from './views/pages/pnf-helper';
import AboutPage from './views/pages/about';
import './App.css';

const routes = ["home", "fretviz", "pnf-helper", "about", "contact"];

function App() {
  const [page, setPage] = useState('home');
  const [darkMode, setDarkMode] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);


  useEffect(() => {
    // On mount, set page from hash
    let hash = window.location.hash.replace('#', '');
    // Check if hash starts with a valid route (e.g., "fretviz-privacy-policy" -> "fretviz")
    let matchedRoute = routes.find(route => hash === route || hash.startsWith(route + '-'));
    if (matchedRoute) {
      setPage(matchedRoute);
    } else {
      setPage('home');
    }
    // Listen for hash changes
    const onHashChange = () => {
      const hash = window.location.hash.replace('#', '');
      const matchedRoute = routes.find(route => hash === route || hash.startsWith(route + '-'));
      if (matchedRoute) setPage(matchedRoute);
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  useEffect(() => {
    document.body.classList.toggle('dark-mode', darkMode);
  }, [darkMode]);

  // Nav hide/show on scroll
  useEffect(() => {
    let lastScroll = 0;
    const nav = document.querySelector('nav');
    const onScroll = () => {
      const currentScroll = window.pageYOffset;
      if (nav) {
        if (currentScroll > lastScroll && currentScroll > 100) {
          nav.style.transform = 'translateY(-100%)';
        } else {
          nav.style.transform = 'translateY(0)';
        }
      }
      lastScroll = currentScroll;
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (route) => {
    setPage(route);
    window.location.hash = route;
    window.scrollTo(0, 0);
    setMobileMenuOpen(false);
  };

  return (
    <>
      {/* Navigation */}
      <nav>
        <div className="nav-container">
          <button
            className="burger-menu"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <div className="logo" onClick={() => handleNav('home')}>Woolworth Software</div>
          <ul className="nav-links desktop-only">
            <li className={`nav-link${page === 'home' ? ' active' : ''}`} onClick={() => handleNav('home')}>Home</li>
            <li className={`nav-link${page === 'fretviz' ? ' active' : ''}`} onClick={() => handleNav('fretviz')}>FretViz</li>
            <li className={`nav-link${page === 'pnf-helper' ? ' active' : ''}`} onClick={() => handleNav('pnf-helper')}>P&F Helper</li>
            <li className={`nav-link${page === 'about' ? ' active' : ''}`} onClick={() => handleNav('about')}>About</li>
            <li className={`nav-link${page === 'contact' ? ' active' : ''}`} onClick={() => handleNav('contact')}>Contact</li>
          </ul>
          <button
            id="theme-toggle"
            className="btn btn-secondary desktop-only"
            style={{ marginLeft: '1rem' }}
            onClick={() => setDarkMode((d) => !d)}
          >
            {darkMode ? 'Light Mode' : 'Dark Mode'}
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div className={`mobile-menu-overlay${mobileMenuOpen ? ' active' : ''}`} onClick={() => setMobileMenuOpen(false)}></div>

      {/* Mobile Menu */}
      <div className={`mobile-menu${mobileMenuOpen ? ' active' : ''}`}>
        <ul className="mobile-nav-links">
          <li className={`nav-link${page === 'home' ? ' active' : ''}`} onClick={() => handleNav('home')}>Home</li>
          <li className={`nav-link${page === 'fretviz' ? ' active' : ''}`} onClick={() => handleNav('fretviz')}>FretViz</li>
          <li className={`nav-link${page === 'pnf-helper' ? ' active' : ''}`} onClick={() => handleNav('pnf-helper')}>P&F Helper</li>
          <li className={`nav-link${page === 'about' ? ' active' : ''}`} onClick={() => handleNav('about')}>About</li>
          <li className={`nav-link${page === 'contact' ? ' active' : ''}`} onClick={() => handleNav('contact')}>Contact</li>
        </ul>
        <button
          className="btn btn-secondary mobile-theme-toggle"
          onClick={() => setDarkMode((d) => !d)}
        >
          {darkMode ? 'Light Mode' : 'Dark Mode'}
        </button>
      </div>

      {/* Pages */}
      <div id="home" className={`page${page === 'home' ? ' active' : ''}`}>{page === 'home' && <HomePage onContact={() => handleNav('contact')} onProducts={() => handleNav('fretviz')} />}</div>
      <div id="fretviz" className={`page${page === 'fretviz' ? ' active' : ''}`}>{page === 'fretviz' && <FretVizPage />}</div>
      <div id="pnf-helper" className={`page${page === 'pnf-helper' ? ' active' : ''}`}>{page === 'pnf-helper' && <PnfHelperPage />}</div>
      <div id="about" className={`page${page === 'about' ? ' active' : ''}`}>{page === 'about' && <AboutPage />}</div>
      <div id="contact" className={`page${page === 'contact' ? ' active' : ''}`}>{page === 'contact' && <ContactPage />}</div>
    </>
  );
}

export default App;
